<template>
  <v-container fluid>
    <v-dialog v-model="showConfirmation" max-width="400px">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          <div>
            <h3 class="headline mb-0">Delete Member Share</h3>
          </div>     
        </v-card-title>
        <v-card-text>
          Are you sure you want to delete {{sortedPhotos.length}} member share photos? You should only do this <strong>after</strong> the monthly meeting. You cannot undo this action.
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn text color="info" @click="showConfirmation = false">Cancel</v-btn>
          <v-btn text color="error" @click="deleteMemberShareImages()">Delete Member Share Photos</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-alert :value="checkingForImages" type="info">
      Checking to see what images you have already uploaded...
    </v-alert>
    <div v-if="!checkingForImages">
      <v-alert :value="memberShareImages.length == 0" type="info">
        You have not yet uploaded any member share &amp; peer feedback images for this month's presentation. Please upload up to two images, no larger than 1920x1080 pixels.
        No images should be sent to the projectionist by any other means.</v-alert>
      <v-alert :value="memberShareImages.length == 1" type="info">
        You may upload a second image for this month's presentation.
      </v-alert>
      <v-alert :value="memberShareImages.length > 1" type="info">
        You have uploaded the maximum of two images for member share &amp; peer feedback. If you change your mind about which images to share, you may delete one or both of the images below.
      </v-alert>

      <DropUpload
        uploadWhere="projectionist"
        v-if="memberShareImages.length < 3"
        @uploadComplete='refreshImages'
        :transparent=false
        :clickable=true
        :maxFiles=2
      >
        <div class="dropzone-custom-content elevation-5">
          <v-icon large>cloud_upload</v-icon>
          <h3 class="dropzone-custom-title">Click to select files from your computer, no larger than 1920x1080 pixels</h3>
          <div class="subtitle">...or drag and drop files here...</div>
        </div>
      </DropUpload>
      <v-layout row wrap>
        <v-flex xs12 d-flex pa-2>
          <v-card v-for="image in memberShareImages"
            :key="image.fileName"
          >
            <v-img
              :src="website + '/memberlogin/projection/memberShare/everyone/slides/' + image.fileName + '?rnd=' + Math.random()"
              aspect-ratio="1"
              class="grey lighten-2"
              :contain="true"
              height="350px"
            >
            </v-img>
            <div class="grey lighten-2 pa-2"><v-icon large color="success">check</v-icon>This photo has been uploaded for member share</div>
            <v-btn
              @click="deleteImage(image.id)"
              color="error"
              absolute
              dark
              small
              top
              right
              fab
            >
              <v-icon>delete</v-icon>
            </v-btn>
          </v-card>
        </v-flex>
      </v-layout>
    </div>
    <v-container v-if="checkingForImages" text-center>
      <v-progress-circular class="text-center"
        indeterminate
        color="primary"
      ></v-progress-circular>
    </v-container>
    <v-card v-if="!checkingForImages">
      <v-card-title primary-title>
        <v-layout row wrap>
          <v-flex xs12>
          <div class="text-subtitle-2">{{ month }}'s Member Share &amp; Peer Feedback Topic: <span class="font-weight-black">{{ memberShareTitle }}</span></div>
            <span class="text-subtitle-2 grey--text">
             {{longDate}}
            </span>
          </v-flex>
          <v-flex xs12>
            <span class="text-body-2 text-break" v-html="memberShareDesc"></span>
          </v-flex>
        </v-layout>
      </v-card-title>
    </v-card>
    <v-layout row wrap>
    <v-btn v-if="$store.state.roles.includes('projectionist')" color="success" @click="openSlideshow()">Slideshow</v-btn>
    <v-spacer/>
    <v-btn v-if="$store.state.roles.includes('projectionist') || $store.state.roles.includes('ro_projection')" color="success" @click="download()">Download {{sortedPhotos.length}} Member Share photos</v-btn>
    <v-spacer/>
    <v-btn v-if="$store.state.roles.includes('projectionist')" color="error" @click="showConfirmation = true">Delete {{sortedPhotos.length}} Member Share Photos</v-btn>
    </v-layout>
    <v-card v-if="$store.state.roles.includes('projectionist') || $store.state.roles.includes('ro_projection')">
      <v-layout row wrap>
        <v-flex
          v-for="(photo) in sortedPhotos"
          :key="photo.fileName" pa-1
        >
          <v-card class="rounded-slide elevation-10">
            <v-container fill-height fluid>
              <v-layout column>
                <v-img
                  :src="website + '/memberlogin/projection/memberShare/everyone/thumbs/'+photo.fileName"
                  :lazy-src="website + '/memberlogin/projection/memberShare/everyone/thumbs/'+photo.fileName"
                  class="imgthumb"
                />
                <div class="white--text caption">{{photo.fileName}}</div>
              </v-layout>
            </v-container>
          </v-card>
        </v-flex>
      </v-layout>
    </v-card>
  </v-container>
</template>

<script>
import DropUpload from '@/components/DropUpload'
import { TokenService } from '@/services/storage.service'
import axios from 'axios'

export default {
  components: {
    DropUpload
  },
  watch: {
    '$refs.upload' () {
      this.refreshImages()
    }
  },
  created () {
    this.loadMemberSharePhotos()
    this.refreshImages()
    this.token = TokenService.getToken()
    this.username = TokenService.getUsername()
  },
  computed: {
    website: function () {
      return process.env.VUE_APP_WEBSITE
    },
    sortedPhotos: function () {
      function compare (a, b) {
        if (a.fileName < b.fileName) {
          return -1
        }
        if (a.fileName > b.fileName) {
          return 1
        }
        return 0
      }
      return this.photos.sort(compare)
    }
  },
  data () {
    return {
      memberShareImages: [],
      photos: [],
      checkingForImages: true,
      memberShareDesc: '',
      memberShareTitle: '',
      month: '',
      longDate: '',
      files: [],
      token: '',
      username: '',
      showConfirmation: false
    }
  },
  methods: {
    openSlideshow () {
      window.open('/memberlogin2/slideshow.php', '_blank')
    },
    toggle () {
      this.$router.push('/lightbox/membershare/0/0')
    },

    download () {
		alert('window.open')
      window.open(process.env.VUE_APP_WEBSITE + '/memberlogin/projectionist.php', '_blank')
    },
    deleteMemberShareImages () {
      var bodyFormData = new FormData()
      bodyFormData.append('Username', TokenService.getUsername())
      bodyFormData.append('token', TokenService.getToken())
      axios.post(process.env.VUE_APP_WEBSITE + '/memberlogin2/api_deleteMemberShare.php', bodyFormData)
      .then(result => {
        this.result = result
        this.photos = []
        alert('Confirmed: Member Share upload area has been cleared')
        this.showConfirmation = false
      }, error => {
        this.photos = []
        console.error(error)
      })
    },
    refreshImages () {
      this.checkingForImages = true
      var bodyFormData = new FormData()
      bodyFormData.append('Username', TokenService.getUsername())
      bodyFormData.append('token', TokenService.getToken())
      bodyFormData.append('JSON', 'true')
      axios.post(process.env.VUE_APP_WEBSITE + '/memberlogin2/api_login.php', bodyFormData)
      .then(response => {
        this.checkingForImages = false
        if (response.data.error === 'Wrong username or password') {
          this.checkingForImages = false
        } else {
          //  TODO: this duplicates code in Signin.vue, so we know how many membershare images were uploaded on the main Landing page
          this.$store.commit('setLoggedIn', true)
          TokenService.saveToken(response.data.token)
          this.$store.commit('setRoles', response.data.roles)
          this.$store.commit('setMemberName', response.data.firstName + ' ' + response.data.lastName)
          this.$store.commit('setMemberInfo', response.data)

          this.memberShareDesc = response.data.memberShare.memberShareDesc
          this.memberShareTitle = response.data.memberShare.memberShareTitle
          this.month = response.data.memberShare.month
          this.longDate = response.data.memberShare.longDate
          this.memberShareImages = []
          response.data.memberShareImages.forEach(element => {
            this.memberShareImages.push(element)
          })
        }
      })
      .catch(error => {
        this.checkingForImages = false
        this.$router.push('/signin?redirect=/membershare')
        console.log(error)
      })
    },
    loadMemberSharePhotos () {
      axios({ method: 'GET',
        'url': process.env.VUE_APP_WEBSITE + '/memberlogin2/api_listgallery.php?galleryOrMemberShare=memberShare&memberName=memberShare&JSON=true'
      }).then(result => {
        this.photos = []
        result.data.photoshoot[0].photos.forEach(element => {
          this.photos.push(element)
        })
      }, error => {
        this.photos = []
        console.error(error)
      })
    },
    deleteImage (imageID) {
      var bodyFormData = new FormData()
      bodyFormData.append('Username', TokenService.getUsername())
      bodyFormData.append('token', TokenService.getToken())
      bodyFormData.append('JSON', 'true')
      axios.post(process.env.VUE_APP_WEBSITE + '/memberlogin2/api_deleteImage.php?JSON=true&memberShareImageID=' + imageID, bodyFormData).then((response) => {
        if (response.data.error === 'Wrong username or password') {
        } else {
          this.refreshImages()
        }
      }, function (error) {
        alert('Signin:' + error)
      })
    }
  }
}
</script>

<style scoped>
.rounded-slide {
  border-radius: 10px !important;
  width: 180px;
  height: 180px;
  background-color: #404040 !important;
}
.imgthumb {
    border: 1px solid #aaaaaa;
    max-width: 130px; 
    max-height: 130px;
}
.my-text-style >>> .v-text-field__slot input {
  position: absolute;
  bottom: 9px;
  color: white;
}
</style>
